import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { PRODUCT_NAME, recentBuyers } from '../data/salesContent';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % recentBuyers.length);
      }, 5500);
    };
    const first = setTimeout(show, 6000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 sm:right-auto" aria-live="polite" data-id="element-48" data-mp="1gynft8kxm4hr">
      <AnimatePresence data-id="element-49" data-mp="16468auzjwzfe">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 overflow-hidden rounded-xl border border-rose/30 bg-white py-3 pl-4 pr-9 shadow-xl shadow-ink/15 sm:w-72" data-id="element-50" data-mp="117fnxvgprho6">
            <span className="absolute inset-y-0 left-0 w-1 bg-rose" aria-hidden="true" data-id="element-51" data-mp="x6cblixvk3rp" />
            <span className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-rose text-white" data-id="element-52" data-mp="s5ye2utwgc7x">
              <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-53" data-mp="28j4z2hjmu61y" />
              <span className="absolute -right-0.5 -top-0.5 flex h-2.5 w-2.5" aria-hidden="true" data-id="element-54" data-mp="23lwhoj6b661r">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sage opacity-75 motion-reduce:animate-none" data-id="element-55" data-mp="2ap30h91dqoan" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full border-2 border-white bg-sage-dark" data-id="element-56" data-mp="2fltelqtmj9tf" />
              </span>
            </span>
            <div className="min-w-0 text-xs leading-snug" data-id="element-57" data-mp="2pmdjd3gcqwge">
              <p className="font-bold uppercase tracking-wider text-rose-dark" data-id="element-58" data-mp="2pjran0hq6awl">Compra reciente</p>
              <p className="mt-0.5 text-ink" data-id="element-59" data-mp="1rvz59j8ik3dx">
                <span className="font-semibold" data-id="element-60" data-mp="1wwdeh4lupjdj">{buyer.name}</span> de {buyer.city}, Argentina compró el{' '}
                <span className="font-semibold" data-id="element-61" data-mp="21v84aqi8k875">{PRODUCT_NAME}</span>
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded p-1 text-ink-soft transition-colors duration-150 hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-62" data-mp="26o16p7q8f4g2">
              <XIcon className="h-3.5 w-3.5" data-id="element-63" data-mp="3rhghsxntdovz" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}